import React, { useState, useEffect } from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom'; // For navigation
import PersonIcon from '@mui/icons-material/Person'; // Icons
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import SchoolIcon from '@mui/icons-material/School';
import SupportIcon from '@mui/icons-material/Support';

const HeaderComponent = () => {
  const navigate = useNavigate();

  const handleContactClick = () => {
    navigate('/contact-us'); // Navigate to contact page when clicked
  };

  return (
    <Box className="component" sx={{
      textAlign: 'center',
      py: { xs: 4, sm: 6 },  // Responsive padding
      color: 'white',
      backgroundSize: 'cover',
      position: 'relative',
      // minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      px: { xs: 2, md: 4 }, 
       // Responsive padding for side spacing
    }} >
      {/* Title Text */}
      <Typography variant="h4" sx={{ 
        fontWeight: 'bold', 
        mb: 2, 
        color: 'rgba(57,69,78,2)', 
        textAlign: 'center',
        fontSize: { xs: '1.5rem', sm: '2rem', }, 
        // Responsive font size
      }} className='component'>
        Is Academic Success Our <span style={{ background: "linear-gradient(-96deg, rgb(194 183 183 / 0%) 0%, rgb(255 249 220 / 4%) 28%, rgb(255, 162, 49) 100%, rgb(255 255 255 / 0%) 100%)" }}>
          Topmost Priority?
        </span>
      </Typography>
      <Typography variant="h6" sx={{
        mb: 4,
        color: 'rgba(0,0,0,0.7)',
        textAlign: 'center',
        fontSize: { xs: '1rem', sm: '1.2rem' }, // Responsive font size
      }}>
        Absolutely, at The Assignment Help India. We provide comprehensive support and services <br /> tailored to enhance your educational journey. Contact us now!
      </Typography>

      {/* Counter Section */}
      <CounterComponent />

      {/* Contact Button */}
      <Button
        className='btn-2'
        variant="contained"
        onClick={handleContactClick}
        sx={{
          backgroundColor: '#f9a339',
          mt: 6, 
          width: { xs: '150px', sm: '200px' },  // Responsive width
          mx: 'auto',  // Center the button
          display: 'block', 
          fontSize: { xs: '0.8rem', sm: '1rem' }  // Responsive font size
        }}>
        Contact us
      </Button>
    </Box>
  );
};

// Counter Component (with new animation and icons)
const CounterComponent = () => {
  const [counts, setCounts] = useState([0, 0, 0, 0, 0]);

  useEffect(() => {
    const targetNumbers = [950, 640, 25, 1100, 24];
    const interval = setInterval(() => {
      setCounts((prev) => prev.map((count, idx) => (count < targetNumbers[idx] ? count + 1 : count)));
    }, 50);

    return () => clearInterval(interval); // Clean up interval on component unmount
  }, []);

  const icons = [
    <PersonIcon fontSize="large" sx={{ color: "#f9a339" }} />,
    <CheckCircleIcon fontSize="large" sx={{ color: "#f9a339" }} />,
    <AssignmentIndIcon fontSize="large" sx={{ color: "#f9a339" }} />,
    <SchoolIcon fontSize="large" sx={{ color: "#f9a339" }} />,
    <SupportIcon fontSize="large" sx={{ color: "#f9a339" }} />,
  ];

  return (
    <Grid container spacing={2} justifyContent="center" sx={{ mt: 4 }} className='component'>
      {['Happy Students',  'Certified Writers', 'Admission', 'Hours Support'].map((label, idx) => (
        <Grid item xs={6} sm={3} md={2.4} lg={2} key={label}> {/* Responsive grid column sizes */}
          <motion.div
            initial={{ scale: 0.95, opacity: 0 }} 
            animate={{ scale: [1, 1.05, 1], opacity: [0, 1] }} 
            transition={{ duration: 0.6, ease: 'easeInOut' }} 
          >
            <Box sx={{
              background: "#012e57",
              textAlign: 'center',
              borderRadius: 2,
              padding: { xs: 2, md: 3 },  // Responsive padding
              width: '100%',
              maxWidth: { xs: 150, md: 200 }, // Responsive max width
              mx: 'auto',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            }}
            >
              {icons[idx]} 
              <Typography variant="h4" color={'#ffffff'} sx={{ fontSize: { xs: '1.5rem', sm: '2rem' } }}>
                {counts[idx]}
              </Typography>
              <Typography variant="subtitle1" sx={{ color: "#f9a339", fontSize: { xs: '0.8rem', sm: '1rem' } }}>
                {label}
              </Typography>
            </Box>
          </motion.div>
        </Grid>
      ))}
    </Grid>
  );
};

// Combined Component
const CombinedComponent = () => {
  return (
    <Box>
      <HeaderComponent />
    </Box>
  );
};

export default CombinedComponent;
